import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getICalUnit, getICalUnitLite } from 'modules/_common/api';
import { useLite } from 'modules/_common/hooks';

export const useQueryICal = (unitId: string) => {
  const { isLite } = useLite();

  const apiCall = isLite ? getICalUnitLite : getICalUnit;

  return useQuery([QUERY_KEYS.RENTALS_CM_ICAL_UNIT, unitId], () => apiCall({ unitId }));
};
